import request from '@/utils/request'
// 商品管理
// 分页查询
export function queryByPage(params) {
  return request({
    url: '/mall/demandstock/queryByPage',
    method: 'post',
    params
  })
}
// /demandstock/insert
// 新增
export function insert(params) {
  return request({
    url: '/mall/demandstock/insert',
    method: 'post',
    params
  })
}

// 购物车商品删除接口
// /mall/ordermanage/shoppingcart/deleteCards  post
export function deleteCards(params) {
  return request({
    url: '/mall/ordermanage/shoppingcart/deleteCards',
    method: 'post',
    params
  })
}

// 购物车修改接口
// /mall/ordermanage/shoppingcart/updateCards post
export function updateCards(data) {
  return request({
    url: '/mall/ordermanage/shoppingcart/updateCards',
    method: 'post',
    data
  })
}

// 获取购物车数据
// /mall/ordermanage/shoppingcart/selectCards post
export function selectCards() {
  return request({
    url: '/mall/ordermanage/shoppingcart/selectCards',
    method: 'post'
  })
}
// 需方商品管理通过编号查询
export function getById(params) {
  return request({
    url: '/mall/demandstock/getById',
    method: 'get',
    params
  })
}
// 修改
export function modify(params) {
  return request({
    url: '/mall/demandstock/modify',
    method: 'post',
    params
  })
}
// 通过需方商品查询供方商品信息
export function queryProviderInfo(params) {
  return request({
    url: '/mall/demandstock/queryProviderInfoByDemandStockId',
    method: 'post',
    params
  })
}
// 加入购物车
export function addShoppingCart(params) {
  return request({
    url: '/mall/stockmanage/mallstorestock/addShoppingCart',
    method: 'post',
    params
  })
}
// 删除购物车
export function deleteCardss(params) {
  return request({
    url: '/mall/ordermanage/shoppingcart/deleteCards',
    method: 'post',
    params
  })
}
// 加入收藏,关注店铺
export function collectStock(mallstoreStockId, mallstoreId, operationType) {
  return request({
    url: `/mall/stockmanage/mallstorestock/collectStock/${mallstoreStockId}/${mallstoreId}/${operationType}`,
    method: 'get'
  })
}

// 导出Excel
export function excelExport(params) {
  return request({
    url: '/mall/demandstock/excel/queryByPage',
    method: 'post',
    params,
    responseType: 'blob'
  })
}
// 导入Excel
export function importExcel(data) {
  return request({
    url: '/mall/demandstock/excel/importExcel',
    method: 'post',
    data,
    timeout: 90 * 1000
  })
}

// 店铺首页接口
// 查询店铺信息
export function queryMallStoreInfo(params) {
  return request({
    url: `/mall/storemanage/mallstore/queryMallStoreNavigation`,
    method: 'post',
    params
  })
}
// 供方单位信息
export function queryMallStoreProviderUnitInfo(FMallStoreId) {
  return request({
    url: `/mall/storemanage/mallstore/queryMallStoreProviderUnitInfo/${FMallStoreId}`,
    method: 'get'
  })
}
// 查询店铺标题栏的信息
export function queryStoreTitleTypeInfo(params) {
  return request({
    url: `/mall/storemanage/mallstore/queryStoreTitleTypeInfo`,
    method: 'post',
    params
  })
}
// 查询店铺商品分页信息
export function queryMallStoreStockInfo(params) {
  return request({
    url: `/mall/storemanage/mallstore/queryMallStoreStockInfo`,
    method: 'post',
    params
  })
}

// 测试
export function querySameSeriesStock(data) {
  return request({
    url: `/mall/stockmanage/mallstorestock/querySameSeriesStock`,
    method: 'post',
    data
  })
}

//历史价格
export function getHistoryPic(params) {
  return request({
    url: `/mall/demandstock/queryStockHistoryPrice`,
    method: 'GET',
    params
  })
}
//查询接口
export function getTabData(params) {
  return request({
    url: `/mall/demandstock/queryProviderProvisioningInfo`,
    method: 'post',
    params
  })
}

